// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-StudyReference-module__alertBanner";
var _2 = "webpack-concepts-Extraction-StudyList-StudyReference-module__authors";
var _3 = "webpack-concepts-Extraction-StudyList-StudyReference-module__libkeyLink";
var _4 = "webpack-concepts-Extraction-StudyList-StudyReference-module__source";
var _5 = "webpack-concepts-Extraction-StudyList-StudyReference-module__studyReference";
var _6 = "webpack-concepts-Extraction-StudyList-StudyReference-module__title";
var _7 = "webpack-concepts-Extraction-StudyList-StudyReference-module__tools";
export { _1 as "alertBanner", _2 as "authors", _3 as "libkeyLink", _4 as "source", _5 as "studyReference", _6 as "title", _7 as "tools" }
